import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

// Global function to show debug messages on screen
(window as any).showDebugMessage = (message: string) => {
  const debugDiv = document.getElementById('debug-message') || (() => {
    const div = document.createElement('div');
    div.id = 'debug-message';
    div.style.position = 'fixed';
    div.style.top = '50%';
    div.style.left = '50%';
    div.style.transform = 'translate(-50%, -50%)';
    div.style.width = '80%';
    div.style.maxWidth = '600px';
    div.style.backgroundColor = 'rgba(0,0,0,0.9)';
    div.style.color = 'white';
    div.style.padding = '20px';
    div.style.fontSize = '14px';
    div.style.zIndex = '10000';
    div.style.border = '2px solid #00ff00';
    div.style.borderRadius = '10px';
    div.style.wordWrap = 'break-word';
    document.body.appendChild(div);
    return div;
  })();
  
  debugDiv.innerHTML = `<h3>🔧 Club Increment Debug</h3><pre>${message}</pre><button onclick="document.getElementById('debug-message').style.display='none'" style="margin-top:10px; padding:5px 10px;">Close</button>`;
  debugDiv.style.display = 'block';
};

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
